export default __webpack_public_path__ + "static/media/Stethescope.202615c4.png";